import React, { useState } from 'react';

const EditUserModal = ({ user, areas, onSave, onClose }) => {
    const [username, setUsername] = useState(user.username);
    const [email, setEmail] = useState(user.email);
    const [role, setRole] = useState(user.role);
    const [areaSigla, setAreaSigla] = useState(user.areaSigla || ''); 
    const [password, setPassword] = useState(''); 
    const [isActive, setIsActive] = useState(user.isActive); 

    const handleSave = () => {
        const updatedData = {
            username,
            email,
            role,
            areaSigla: areaSigla === '' ? null : areaSigla,
            isActive, 
        };
        if (password) {
            updatedData.password = password; 
        }
        onSave(user.id, updatedData);
        onClose();
    };

    const roles = ['EMISOR', 'VISOR', 'ADMIN'];

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
                <h3 className="text-xl font-bold mb-4">Editar Usuario: {user.username}</h3>
                <div className="mb-4">
                    <label htmlFor="username" className="block text-gray-700 text-sm font-bold mb-2">Usuario:</label>
                    <input
                        type="text"
                        id="username"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email:</label>
                    <input
                        type="email"
                        id="email"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="role" className="block text-gray-700 text-sm font-bold mb-2">Rol:</label>
                    <select
                        id="role"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        required
                    >
                        {roles.map((r) => (
                            <option key={r} value={r}>{r}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="areaSigla" className="block text-gray-700 text-sm font-bold mb-2">Sigla de Área:</label>
                    <select
                        id="areaSigla"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                        value={areaSigla}
                        onChange={(e) => setAreaSigla(e.target.value)}
                    >
                        <option value="">-- Sin Área --</option> 
                        {areas.map((area) => (
                            <option key={area.id} value={area.abbreviation}>{area.abbreviation} - {area.name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Nueva Contraseña (opcional):</label>
                    <input
                        type="password"
                        id="password"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Dejar vacío para no cambiar"
                    />
                </div>
                <div className="mb-4 flex items-center">
                    <input
                        type="checkbox"
                        id="isActive"
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                    <label htmlFor="isActive" className="text-gray-700 text-sm font-bold">
                        Usuario Activo
                    </label>
                </div>

                <div className="flex justify-end gap-2">
                    <button
                        className="bg-gray-700 text-white font-bold py-2 px-4 rounded-lg hover:bg-gray-600 transition duration-200 ease-in-out" 
                        onClick={onClose}
                    >
                        Cancelar
                    </button>
                    <button
                        className="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-200 ease-in-out" 
                        onClick={handleSave}
                    >
                        Guardar Cambios
                    </button>
                </div>
            </div>
        </div>
    );
};


const UserManagePanel = ({ users, onCreateUser, onUpdateUser, onSetUserActiveStatus, areas, onCreateArea, onUpdateArea, onDeleteArea }) => { 
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newUserEmail, setNewUserEmail] = useState('');
    const [newUserRole, setNewUserRole] = useState('EMISOR');
    const [newUserAreaSigla, setNewUserAreaSigla] = useState('');

    const [editingUser, setEditingUser] = useState(null); 

    const [newAreaName, setNewAreaName] = useState('');
    const [newAreaAbbreviation, setNewAreaAbbreviation] = useState('');
    const [editingArea, setEditingArea] = useState(null); 

    const handleCreateUserSubmit = (event) => {
        event.preventDefault();
        if (!newUsername || !newPassword || !newUserEmail || !newUserRole) {
            alert('Todos los campos del nuevo usuario son requeridos.');
            return;
        }
        onCreateUser(newUsername, newPassword, newUserRole, newUserEmail, newUserAreaSigla === '' ? null : newUserAreaSigla); 
        setNewUsername('');
        setNewPassword('');
        setNewUserEmail('');
        setNewUserRole('EMISOR');
        setNewUserAreaSigla('');
    };

    const handleCreateAreaSubmit = (event) => {
        event.preventDefault();
        if (!newAreaName || !newAreaAbbreviation) {
            alert('Nombre y abreviatura del área son requeridos.');
            return;
        }
        onCreateArea({ name: newAreaName, abbreviation: newAreaAbbreviation });
        setNewAreaName('');
        setNewAreaAbbreviation('');
    };

    const handleUpdateAreaSubmit = (event) => {
        event.preventDefault();
        if (!editingArea.name || !editingArea.abbreviation) {
            alert('Nombre y abreviatura del área son requeridos.');
            return;
        }
        onUpdateArea(editingArea.id, { name: editingArea.name, abbreviation: editingArea.abbreviation });
        setEditingArea(null); 
    };

    return (
        <div className="p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Gestión de Usuarios y Áreas</h2>

            <div className="mb-8 p-4 border rounded-lg bg-gray-50">
                <h3 className="text-xl font-semibold mb-3">Crear Nuevo Usuario</h3>
                <form onSubmit={handleCreateUserSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="newUsername" className="block text-gray-700 text-sm font-bold mb-2">Usuario:</label>
                        <input
                            type="text"
                            id="newUsername"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={newUsername}
                            onChange={(e) => setNewUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="newPassword" className="block text-gray-700 text-sm font-bold mb-2">Contraseña:</label>
                        <input
                            type="password"
                            id="newPassword"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="newUserEmail" className="block text-gray-700 text-sm font-bold mb-2">Email:</label>
                        <input
                            type="email"
                            id="newUserEmail"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={newUserEmail}
                            onChange={(e) => setNewUserEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="newUserRole" className="block text-gray-700 text-sm font-bold mb-2">Rol:</label>
                        <select
                            id="newUserRole"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={newUserRole}
                            onChange={(e) => setNewUserRole(e.target.value)}
                            required
                        >
                            <option value="EMISOR">EMISOR</option>
                            <option value="VISOR">VISOR</option>
                            <option value="ADMIN">ADMIN</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="newUserAreaSigla" className="block text-gray-700 text-sm font-bold mb-2">Sigla de Área (opcional):</label>
                        <select
                            id="newUserAreaSigla"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={newUserAreaSigla}
                            onChange={(e) => setNewUserAreaSigla(e.target.value)}
                        >
                            <option value="">-- Sin Área --</option>
                            {areas.map((area) => (
                                <option key={area.id} value={area.abbreviation}>{area.abbreviation} - {area.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="md:col-span-2 flex justify-end">
                        <button
                            type="submit"
                            className="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-200 ease-in-out" 
                        >
                            Crear Usuario
                        </button>
                    </div>
                </form>
            </div>

            <div className="mb-8">
                <h3 className="text-xl font-semibold mb-3">Usuarios Existentes</h3>
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 border-b">
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Usuario</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Email</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Rol</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Área</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Estado</th> 
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user) => (
                                <tr key={user.id} className="border-b last:border-b-0 hover:bg-gray-50">
                                    <td className="py-2 px-4 text-sm text-gray-800">{user.username}</td>
                                    <td className="py-2 px-4 text-sm text-gray-800">{user.email}</td>
                                    <td className="py-2 px-4 text-sm text-gray-800">{user.role}</td>
                                    <td className="py-2 px-4 text-sm text-gray-800">{user.areaSigla || 'N/A'}</td>
                                    <td className="py-2 px-4 text-sm text-gray-800">
                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${user.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                            {user.isActive ? 'Activo' : 'Inactivo'}
                                        </span>
                                    </td> 
                                    <td className="py-2 px-4 text-sm flex gap-2">
                                        <button
                                            className="bg-gray-700 text-white font-bold py-1 px-3 rounded-lg text-xs hover:bg-gray-600 transition duration-200 ease-in-out" 
                                            onClick={() => setEditingUser(user)}
                                        >
                                            Editar
                                        </button>
                                        <button
                                            className={`${user.isActive ? 'bg-red-700 hover:bg-red-600' : 'bg-green-700 hover:bg-green-600'} text-white font-bold py-1 px-3 rounded-lg text-xs transition duration-200 ease-in-out`} 
                                            onClick={() => onSetUserActiveStatus(user.id, !user.isActive)} 
                                        >
                                            {user.isActive ? 'Inhabilitar' : 'Habilitar'} 
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {editingUser && (
                <EditUserModal
                    user={editingUser}
                    areas={areas}
                    onSave={onUpdateUser}
                    onClose={() => setEditingUser(null)}
                />
            )}

            <div className="p-4 border rounded-lg bg-gray-50">
                <h3 className="text-xl font-semibold mb-3">Gestión de Áreas</h3>
                
                <form onSubmit={editingArea ? handleUpdateAreaSubmit : handleCreateAreaSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label htmlFor="areaName" className="block text-gray-700 text-sm font-bold mb-2">Nombre del Área:</label>
                        <input
                            type="text"
                            id="areaName"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={editingArea ? editingArea.name : newAreaName}
                            onChange={(e) => editingArea ? setEditingArea({ ...editingArea, name: e.target.value }) : setNewAreaName(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="areaAbbreviation" className="block text-gray-700 text-sm font-bold mb-2">Abreviatura (Sigla):</label>
                        <input
                            type="text"
                            id="areaAbbreviation"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={editingArea ? editingArea.abbreviation : newAreaAbbreviation}
                            onChange={(e) => editingArea ? setEditingArea({ ...editingArea, abbreviation: e.target.value.toUpperCase() }) : setNewAreaAbbreviation(e.target.value.toUpperCase())}
                            maxLength="10"
                            required
                        />
                    </div>
                    <div className="md:col-span-2 flex justify-end gap-2">
                        <button
                            type="submit"
                            className="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-200 ease-in-out" 
                        >
                            {editingArea ? 'Actualizar Área' : 'Crear Área'}
                        </button>
                        <button
                            type="button"
                            className="bg-gray-700 text-white font-bold py-2 px-4 rounded-lg hover:bg-gray-600 transition duration-200 ease-in-out" 
                            onClick={() => setEditingArea(null)}
                        >
                            Cancelar Edición
                        </button>
                    </div>
                </form>

                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 border-b">
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Nombre</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Abreviatura</th>
                                <th className="py-2 px-4 text-left text-sm font-semibold text-gray-600">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {areas.map((area) => (
                                <tr key={area.id} className="border-b last:border-b-0 hover:bg-gray-50">
                                    <td className="py-2 px-4 text-sm text-gray-800">{area.name}</td>
                                    <td className="py-2 px-4 text-sm text-gray-800">{area.abbreviation}</td>
                                    <td className="py-2 px-4 text-sm flex gap-2">
                                        <button
                                            className="bg-gray-700 text-white font-bold py-1 px-3 rounded-lg text-xs hover:bg-gray-600 transition duration-200 ease-in-out" 
                                            onClick={() => setEditingArea(area)}
                                        >
                                            Editar
                                        </button>
                                        <button
                                            className="bg-red-700 text-white font-bold py-1 px-3 rounded-lg text-xs hover:bg-red-600 transition duration-200 ease-in-out" 
                                            onClick={() => onDeleteArea(area.id)}
                                        >
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default UserManagePanel;
